<template>
	<div class="test-list-table-wrapper">
		<el-table :data="list" @row-click="onClickTest" row-class-name="row">
			<el-table-column label="名称" prop="test.name" />
			<el-table-column label="状态" :width="14 * 6 + 35">
				<template v-slot:default="slot">
					<p>{{ getStateText(slot.row.state) }}</p>
				</template>
			</el-table-column>
			<el-table-column align="left" label="创建日期">
				<template v-slot:default="slot">
					<div>{{ getDateText(slot.row.created_at) }}</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="global-el-pagination">
			<el-pagination
				background
				v-if="pageSize < total"
				layout="prev, pager, next"
				:page-size="pageSize"
				:total="total"
				@current-change="onPageChange"
			/>
		</div>
	</div>
</template>

<script>
export default {
	created() {
		this.refresh()
	},
	props: {
		type: Number,
		category: String,
		studentId: Number
	},
	data() {
		return {
			list: [],
			pageSize: 10,
			total: 0,
			currentPage: 1
		}
	},

	methods: {
		async refresh() {
			let res = await this.$api.user.listStudentTests(this.studentId, {
				test_type: this.type,
				category: this.category,
				paginate: {
					page: this.currentPage,
					size: this.pageSize
				}
			})
			this.list = res.data
			this.total = res.meta.total
		},
		calcFinishedRate(summary) {
			let total = summary.total
			if (total <= 0) return 0
			let finished = summary.finished
				? summary.finished
				: 0 + summary.reviewing
				? summary.reviewing
				: 0 + summary.frozen
				? summary.frozen
				: 0
			return Math.round((finished / total) * 100)
		},
		onClickTest(row) {
			this.$router.push({
				name: 'teacherViewAnswerSheet',
				params: {
					asid: row.id,
					seid: row.test.serial,
					sbid: row.subject_id
				}
			})
		},
		onPageChange(pageNum) {
			this.currentPage = pageNum
			this.refresh()
		},

		getStateText(value) {
			return this.$api.answersheet.states.toText(value)
		},

		getDateText(datestring) {
			var date = new Date(datestring)
			return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
		}
	},

	watch: {
		type() {
			this.refresh()
		},

		category() {
			this.refresh()
		},

		studentId() {
			this.refresh()
		}
	}
}
</script>

<style lang="scss">
.test-list-table-wrapper {
	.row {
		cursor: pointer;
	}

	.class-list:after {
		content: '/';
		margin: 0 0.5em;
	}

	span.class-list:last-child::after {
		content: '';
	}
}
</style>
